import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form'
import TextField from '@material-ui/core/TextField'
import Checkbox from '@material-ui/core/Checkbox'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Button from '@material-ui/core/Button';
import LocationPicker from 'react-location-picker';
import FormHelperText from '@material-ui/core/FormHelperText'

const requiredFields = [
  'name',
  'residents',
  'email',
  'notes',
  'sizeofproperty',
  'diet',
  'languages',
  'favquote',
  'aboutme',
  'lat',
  'lng',
  'phantomPic'
]
const validate = values => {
  const errors = {}
  var dontleave = false;
  requiredFields.forEach(field => {
    if (!values[field]) {
      errors[field] = 'Required'
    }
    else {
      dontleave = true;
    }
  })
  window.onbeforeunload = dontleave ? (function(){return 'Are you sure you want to leave?';}) : undefined;
  if (
    values.email &&
    !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)
  ) {
    errors.email = 'Invalid email address'
  }
  if (!(/^-?([1-8]?[1-9]|[1-9]0)\.{1}\d{1,15}/g.test(values.lat))) {
    errors.lat = 'Invalid coordinates. Please enter a decimal longitude value.'
  }
  if (!(/^-?(([-+]?)([\d]{1,3})((\.)(\d+))?)/g.test(values.lng))) {
    errors.lng = 'Invalid coordinates. Please enter a decimal latitude value.'
  }
  if(values.datenschutz !== true) {
    errors['datenschutz'] = "Please accept our data protection guidelines";
  }
  return errors
}
const validatePicture = event => {
  if(document.getElementById("raised-button-file") != null) {
    var theButton = document.getElementById("picUploadButton"),
    picErr = document.getElementById("picErr"),
    picSucc = document.getElementById("picSucc");
    if(!document.getElementById("raised-button-file").value && event.invalid && event.touched) {
      theButton.classList.remove("MuiButton-outlinedPrimary");
      theButton.classList.add("MuiButton-outlinedSecondary");
      picErr.style.display = "";
      picSucc.style.display = "none";
    }
    else {
      theButton.classList.remove("MuiButton-outlinedSecondary");
      theButton.classList.remove("MuiButton-outlinedPrimary");
      picErr.style.display = "none";
      picSucc.style.display = "";
    }
  }
}
const validateCoords = event => {
  if(document.getElementsByClassName("cfield") != null && document.getElementById("selectLocationButton") != null) {
    var empty = true;
    for (let item of document.getElementsByClassName("cfield")) {
      if(item.dataset.error === "true"){empty = false}
    }
    var theButton = document.getElementById("selectLocationButton"),
    locErr = document.getElementById("locErr"),
    locSucc = document.getElementById("locSucc");;
    if(empty && event.invalid && event.touched) {
        theButton.classList.remove("MuiButton-outlinedPrimary");
        theButton.classList.add("MuiButton-outlinedSecondary");
        locErr.style.display = "";
        locSucc.style.display = "none";
    }
    else {
      theButton.classList.remove("MuiButton-outlinedSecondary");
      theButton.classList.remove("MuiButton-outlinedPrimary");
      locErr.style.display = "none";
      locSucc.style.display = "";
    }
  }
}

const renderTextField = ({
  label,
  input,
  meta: { touched, invalid, error },
  ...custom
}) => (
  <TextField
    style={{width: "100%"}}
    label={((requiredFields.includes(input.name)) ? <span>{label}<sup style={{color: 'red'}}>&nbsp;*</sup></span> : <span>{label}</span>)}
    placeholder={label}
    error={touched && invalid}
    helperText={touched && error}
    variant="outlined"
    margin="normal"
    {...input}
    {...custom}
  />
)
const renderCoordField = ({
  label,
  input,
  meta: { touched, invalid, error },
  ...custom
}) => {
   validateCoords({touched: touched, invalid: invalid});
    return(
  <TextField
    style={{width: "100%"}}
    label={((requiredFields.includes(input.name)) ? <span>{label}<sup style={{color: 'red'}}>&nbsp;*</sup></span> : <span>{label}</span>)}
    placeholder={label}
    error={touched && invalid}
    data-error={touched && invalid}
    helperText={touched && error}
    variant="outlined"
    margin="normal"
    inputProps={{className: "cfield"}}
    {...input}
    {...custom}
  />
  )
}
const phP = ({
  label,
  input,
  meta: { touched, invalid, error },
  ...custom
}) => {
   validatePicture({touched: touched, invalid: invalid});
    return(
    <TextField
      style={{display: "none"}}
      label={label}
      placeholder={label}
      error={touched && invalid}
      helperText={touched && error}
      variant="outlined"
      margin="normal"
      {...input}
      {...custom}
    />
)}

const renderCheckbox = ({ input, label, meta: { touched, invalid, error } }) => (
  <div>
    <FormControlLabel
      control={
        <Checkbox
          color="default"
          checked={input.value ? true : false}
          onChange={input.onChange}
        />
      }
      label={label}
    />
    {((touched && invalid) ? <span style={{fontFamily: 'Roboto, Helvetica, Arial, sans-serif', color: 'red'}}>{error}</span> : "")}
  </div>
)
const toclabel = (
  <span>I accept the&nbsp;
    <a
      href="https://www.loveproductions.org/j/privacy"
      target="_blank"
      rel="noopener noreferrer"
    >
      privacy declaration
    </a>
  </span>
)
const renderBigTextField = ({
  label,
  input,
  meta: { touched, invalid, error },
  ...custom
}) => (
  <TextField
    style={{width: "100%"}}
    label={((requiredFields.includes(input.name)) ? <span>{label}<sup style={{color: 'red'}}>&nbsp;*</sup></span> : <span>{label}</span>)}
    placeholder={label}
    multiline
    inputProps={{style:{minHeight: "2cm"}}}
    margin="normal"
    variant="outlined"
    error={touched && invalid}
    helperText={touched && error}
    {...input}
    {...custom}
  />
)
/* Default position */
const defaultPosition = {
  lat: 48.18817454934269,
  lng: 16.51864204407252
};
class MaterialUiForm extends React.Component{
  constructor (props) {
    super(props);

    this.state = {
      address: "Kala Pattar Ascent Trail, Khumjung 56000, Nepal",
      position: {
         lat: "Plase drag the marker on the map",
         lng: "Plase drag the marker on the map"
      },
      map: true,
      coords: false,
    };

    // Bind
    this.handleLocationChange = this.handleLocationChange.bind(this);
  }
  handleLocationChange ({ position, address, places }) {
    this.props.change('lat',position.lng);
    this.props.change('lng',position.lat);
    // Set new location
    this.setState({ position, address });
  }
  toggleMap = event => {
    document.getElementById("mapElement").style.height = this.state.map ? "70vh" : "0vh";
    document.getElementById("advancedText").style.display = this.state.map ? "" : "none";
    document.getElementById("coords").style.maxHeight = !this.state.map ? "0px" : (this.state.coords ? "300px" : "0px");
    this.setState({"map":!this.state.map});
  };
  toggleCoords = event => {
    var nc = !this.state.coords,
    h = nc ? "300px" : "0px";
    document.getElementById("coords").style.maxHeight = h;
    this.setState({"coords":!this.state.coords});
  };
  updatePhantomPicture = event => {
    this.props.change('phantomPic',event.target.value);
  };
  render() {
    const { handleSubmit, pristine, submitting } = this.props;
    return (
      <div>
        <form action="/kinmap/form_recieve.php" method="post" enctype="multipart/form-data" onSubmit={handleSubmit}>
          <div>
            <Field name="name" component={renderTextField} label="Your name" />
          </div>
          <div>
            <Field name="kinname" component={renderTextField} label="Name of kin domain" />
          </div>
          <div>
            <Field name="residents" component={renderTextField} label="Number of residents" />
          </div>
          <div>
            <Field name="sizeofproperty" component={renderTextField} label="Size of property" />
          </div>
          <div>
            <br />
            <Button id="selectLocationButton" color="primary" variant="outlined" onClick={this.toggleMap}>Select location<sup style={{color: 'red'}}>&nbsp;*</sup></Button>
            <span id="locSucc" style={{marginLeft: '10px', display: 'none'}} role="img" aria-label="A location has been selected">✔️</span><span id="locErr" style={{fontFamily: 'Roboto, Helvetica, Arial, sans-serif', color: 'red', marginLeft: '10px', display: 'none'}}>Please select your location or enter <u>valid</u> coordinates.</span>
            <br />
            <FormHelperText style={{marginBottom: '5px'}}>Click "SELECT LOCATION" to show/hide the map. Please select your location/region or the nearest town by moving (click+drag) the marker on the map.</FormHelperText>
          </div>
          <div>
            <LocationPicker
              containerElement={ <div /> }
              mapElement={ <div id="mapElement" style={ {height: "0vh", transitionDuration: "1s"} } /> }
              defaultPosition={defaultPosition}
              onChange={this.handleLocationChange}
            />
            <FormHelperText id="advancedText" style={{display: 'none'}}>Advanced users only: <u style={{cursor: 'pointer'}} onClick={this.toggleCoords}>manually enter coordinates.</u></FormHelperText>
          </div>
          <div id="coords" style={{maxHeight: '0px',overflow: 'hidden',transitionDuration: "1s"}}>
            <Field name="lng" component={renderCoordField} label="Latitude" />
            <Field name="lat" component={renderCoordField} label="Longitude" />
          </div>
          <div>
            <Field name="diet" component={renderTextField} label="Diet" />
          </div>
          <div>
            <Field name="languages" value="english" component={renderTextField} label="Languages spoken" />
          </div>
          <div>
            <Field name="email" component={renderTextField} label="Email" />
          </div>
          <div>
            <Field name="website" component={renderTextField} label="Facebook, Blog or Website" />
          </div>
          <div>
            <Field name="favquote" component={renderBigTextField} label="Favourite quote of the Ringing Cedars Series" />
          </div>
          <Field name="phantomPic" component={phP} label="Picture" />
          <div style={{marginTop: '8px'}}>
            <input
            accept="image/*"
            style={{ display: 'none' }}
            id="raised-button-file"
            type="file"
            name="picture"
            onChange={this.updatePhantomPicture}
          />
          <label htmlFor="raised-button-file">
            <Button id="picUploadButton" variant="outlined" color="primary" component="span">
              Upload picture<sup style={{color: 'red'}}>&nbsp;*</sup>
            </Button>
          </label>
          <span id="picSucc" role="img" aria-label="An image file has been selected" style={{marginLeft: '10px', display: 'none'}}>✔️</span><span id="picErr" style={{fontFamily: 'Roboto, Helvetica, Arial, sans-serif', color: 'red', marginLeft: '10px', display: 'none'}}>Please choose a picture</span>
          <FormHelperText>Please click "UPLOAD PICTURE" and select a picture (max 10MiB)</FormHelperText>
          </div>
          <div>
            <Field name="aboutme" component={renderBigTextField} label="About me/us" />
          </div>
          <div>
            <Field name="datenschutz" component={renderCheckbox} label={toclabel} />
          </div>
          <FormHelperText style={{fontSize: '12pt',color: 'rgba(0,0,0,0.8)'}}>Note: The fields marked with <sup style={{color: 'red'}}>*</sup> must be filled out.</FormHelperText>
          <br />
          <div>
          <Button variant="contained" color="primary" type="submit" disabled={pristine || submitting}>
            Submit
          </Button>
          </div>
        </form>
      </div>
    )
  }
}
export default reduxForm({
  form: 'MaterialUiForm', // a unique identifier for this form
  validate,
})(MaterialUiForm)
